<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn text @click="tornaIndietro" class="mb-4">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Torna all'elenco
                </v-btn>
            </v-col>
        </v-row>

        <!-- Form dati generali ordine -->
        <FormOrdine ref="formOrdineRef" :ordine="ordine" :loading="loading" @salva="salvaOrdine" />

        <!-- Sezione firma e allegati (solo se ordine esistente) -->
        <v-row class="mt-4">
            <!-- 
            <v-col cols="12" md="6">
                <GestioneFirma :ordine-id="ordine.id" :firma-url="ordine.firmaUrl" @firma-salvata="aggiornaFirma" />
            </v-col>
            -->
            <v-col cols="12" md="6">
                <GestioneAllegati :ordine-id="ordine.id" :allegati="ordine.allegati || []"
                    @allegati-aggiornati="aggiornaAllegati" />
            </v-col>
        </v-row>

        <!-- Tabella righe misure (solo se ordine esistente) -->
        <v-row class="mt-4">
            <v-col cols="12">
                <TabellaMisure :ordine-id="ordine.id" :righe="ordine.righe || []" @righe-aggiornate="aggiornaRighe" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { get_ordine, crea_ordine, modifica_ordine, get_numero_ordine } from '@/api/api.misure.js'
import FormOrdine from '@/components/ordini/FormOrdine.vue'
/* import GestioneFirma from '@/components/ordini/GestioneFirma.vue' */
import GestioneAllegati from '@/components/ordini/GestioneAllegati.vue'
import TabellaMisure from '@/components/ordini/TabellaMisure.vue'

export default {
    name: 'DettaglioOrdine',

    components: {
        FormOrdine,
        /* GestioneFirma, */
        GestioneAllegati,
        TabellaMisure
    },

    setup() {
        const router = useRouter()
        const route = useRoute()
        const loading = ref(false)
        const formOrdineRef = ref(null)

        const ordine = ref({
            id: -1,
            numeroCommessa: '',
            data: new Date().toISOString().split('T')[0],
            dataConsegna: null,
            // Dati cliente
            cognomeCliente: '',
            nomeCliente: '',
            ragioneSociale: '',
            viaCliente: '',
            cittaCliente: '',
            capCliente: '',
            emailCliente: '',
            piCfCliente: '',
            telefonoCliente: '',
            // Dati cantiere
            intestazioneCantiere: '',
            viaCantiere: '',
            cittaCantiere: '',
            // Specifiche tecniche
            essenza: '',
            serie: '',
            profilo: '',
            spessore: '',
            verniciatura: '',
            verniciaturaNote: '',
            bicoloreInt: '',
            bicoloreEst: '',
            campione: '',
            persiana: '',
            persianaDettagli: '',
            verniciaturaPersiana: '',
            campionePersiana: '',
            avvolgibili: '',
            coloreAvvolgibili: '',
            accessori: '',
            motore: false,
            antone: '',
            scuroInterno: false,
            zanzarieraTipo: '',
            zanzarieraColore: '',
            cassonetto: '',
            ispezioneCassonetto: '',
            coprifiliInt: '',
            coprifiliEst: '',
            maniglia: '',
            vetro: '',
            smontaggio: false,
            posaSuVecchio: false,
            posaSuFalsoTelaio: false,
            posaATassello: false,
            noleggioCestello: false,
            smaltimento: false,
            // Array
            righe: [],
            allegati: [],
            firmaUrl: null,
            tipoCommessa: 'Rilievo',
            campoMisure: '',
        })

        const caricaOrdine = async () => {
            const id = route.params.id
            if (id === 'nuovo') {
                let res = await get_numero_ordine()
                ordine.value.numeroCommessa = res.data;
                return
            }

            loading.value = true
            try {
                const response = await get_ordine(id)
                ordine.value = response.data || response
            } catch (error) {
                console.error('Errore caricamento ordine:', error)
            }
            loading.value = false
        }

        const salvaOrdine = async (datiOrdine) => {
            loading.value = true
            try {
                if (ordine.value.id > 0) {
                    await modifica_ordine(ordine.value.id, datiOrdine)
                } else {
                    const response = await crea_ordine(datiOrdine)
                    ordine.value = response.data || response
                    router.replace({ name: 'DettaglioOrdine', params: { id: ordine.value.id } })
                }
            } catch (error) {
                console.error('Errore salvataggio ordine:', error)
                alert('Errore durante il salvataggio')
            }
            loading.value = false
        }

        const aggiornaFirma = (firmaUrl) => {
            ordine.value.firmaUrl = firmaUrl
        }

        const aggiornaAllegati = (allegati) => {
            ordine.value.allegati = allegati
        }

        const aggiornaRighe = async (righe) => {
            await caricaOrdine();
            ordine.value.righe = righe
        }

        const tornaIndietro = () => {
            router.push({ name: 'ElencoOrdini' })
        }

        onMounted(() => {
            caricaOrdine()
        })

        return {
            loading,
            ordine,
            formOrdineRef,
            salvaOrdine,
            aggiornaFirma,
            aggiornaAllegati,
            aggiornaRighe,
            tornaIndietro
        }
    }
}
</script>